// src/Footer.js
import React, { useEffect, useMemo, useState } from "react";

const FPS = 10;          // how fast the frames flip
const RUN_TIME = 18;     // seconds to run across the footer

export default function Footer() {
  // load all PNGs from /assets/catbunny (01.png, 02.png, …)
  const frames = useMemo(() => {
    try {
      const ctx = require.context("./assets/catbunny", false, /\.png$/);
      return ctx
        .keys()
        .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
        .map(ctx);
    } catch {
      return [];
    }
  }, []);

  const [i, setI] = useState(0);

  useEffect(() => {
    if (!frames.length) return;
    const t = setInterval(() => setI(n => (n + 1) % frames.length), 1000 / FPS);
    return () => clearInterval(t);
  }, [frames]);

  return (
    <footer className="footer">
      {/* runner (above the text, along the bottom edge) */}
      {frames.length > 0 && (
        <div
          className="catbunny-runner"
          style={{ "--run-time": `${RUN_TIME}s` }}
          aria-hidden="true"
        >
          <img
            src={frames[i]}
            alt=""
            className="catbunny-sprite"
            draggable="false"
          />
        </div>
      )}

      <p className="footer-text">© 2025 Minminmachine. All rights reserved.</p>
    </footer>
  );
}
